import { Box, Divider, Tooltip } from "@mui/material";
import { Edit } from "@mui/icons-material";
import {
  getCurrencyFromSetup,
  getEventTotalValue,
} from "../../../common/EntitiesManagement";
import { getValueInCurrency } from "../../../common/utils";
import localize from "../../../common/localize";

export default function TotalValueItem({
  item,
  canEditServiceValue,
  setEventModel,
  setShowServiceValuesModal,
  customStyle,
  notCentered,
  hideEditPlaceholder,
}) {
  return (
    <Box
      className={`flex gap-2 items-center w-full ${canEditServiceValue ? 'justify-between' : ''}`}
      style={
        !notCentered
          ? {
            gap: "5px",
            alignItems: "center",
            justifyContent: "center",
          }
          : {}
      }
    >
      {canEditServiceValue && canEditServiceValue(item) ? (
        <Tooltip title={localize.edit_values}>
          <button
            onClick={() => {
              setEventModel(item);
              setShowServiceValuesModal(true);
            }}
          >
            <Edit
              style={{
                width: "20px",
                height: "20px",
                color: "#10366E",
              }}
            />
          </button>
        </Tooltip>
      ) : (
        !hideEditPlaceholder && <div style={{ width: "20px" }} />
      )}
      {item.sparePartsValue === item.sparePartsFinalValue &&
        item.executionValue === item.executionFinalValue ? (
        <Tooltip
          title={
            <div className="flex flex-col">
              <p>
                <b>{localize.current_value}</b>
              </p>
              <Divider sx={{ borderColor: "white" }} />
              <p>
                <b>{`${localize.service_value}: `}</b>{" "}
                {getValueInCurrency(
                  getCurrencyFromSetup(),
                  item.executionFinalValue,
                )}
              </p>
              <p>
                <b>{`${localize.spare_parts_value}: `}</b>{" "}
                {getValueInCurrency(
                  getCurrencyFromSetup(),
                  item.sparePartsFinalValue,
                )}
              </p>
              <p>
                <b>{`${localize.additional_costs}: `}</b>{" "}
                {getValueInCurrency(
                  getCurrencyFromSetup(),
                  item.AdditionalCostValue ?? 0,
                )}
              </p>
              <p>
                <b>{`${localize.total_value}: `}</b>{" "}
                {getValueInCurrency(
                  getCurrencyFromSetup(),
                  getEventTotalValue(item, true),
                  true,
                )}
              </p>
            </div>
          }
        >
          <p className={customStyle}>
            {`${getCurrencyFromSetup()} ${new Intl.NumberFormat().format(
              getEventTotalValue(item, true).toFixed(0),
            )}`}
          </p>
        </Tooltip>
      ) : (
        <Tooltip
          title={
            <div className="flex-col">
              <div>
                <p>
                  <b>{localize.original_value}</b>
                </p>
                <Divider sx={{ borderColor: "white" }} />
                <p>
                  <b>{`${localize.service_value}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    item.executionValue,
                  )}
                </p>
                <p>
                  <b>{`${localize.spare_parts_value}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    item.sparePartsValue,
                  )}
                </p>
                <p>
                  <b>{`${localize.additional_costs}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    item.AdditionalCostValue ?? 0,
                    true,
                  )}
                </p>
                <p>
                  <b>{`${localize.total_value}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    getEventTotalValue(item, false),
                    true,
                  )}
                </p>
              </div>
              <div className="my-2">
                <p>
                  <b>{localize.current_value}</b>
                </p>
                <Divider sx={{ borderColor: "white" }} />
                <p>
                  <b>{`${localize.service_value}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    item.executionFinalValue,
                  )}
                </p>
                <p>
                  <b>{`${localize.spare_parts_value}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    item.sparePartsFinalValue,
                  )}
                </p>
                <p>
                  <b>{`${localize.additional_costs}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    item.AdditionalCostValue ?? 0,
                    true,
                  )}
                </p>
                <p>
                  <b>{`${localize.total_value}: `}</b>{" "}
                  {getValueInCurrency(
                    getCurrencyFromSetup(),
                    getEventTotalValue(item, true),
                    true,
                  )}
                </p>
              </div>
            </div>
          }
        >
          <p
            style={{
              color: "red",
            }}
            className={customStyle}
          >
            {`${getValueInCurrency(
              getCurrencyFromSetup(),
              getEventTotalValue(item, true),
              true,
            )}
        `}
          </p>
        </Tooltip>
      )}
    </Box>
  );
}
